import React from 'react';

export default function TipBox() {
    return (
        <article className="tip">
            <h4>How To Use It!</h4>
            <hr className="sidebar-separator" />
            <small>1. Login</small>
            <small>2. Click the Bid Button</small>
            <small>3. Wait for approval</small>
        </article>
    )
}